module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Bolts.b53b1e86.png";